import { addSubheadingsToSidebar, markCurrentSubheading } from "./subheadings";
import detectFancyLinks from "./detectFancyLinks";
import enableToggles from "./enableToggles.js";
import bindColorSwatches from "./bindColorSwatches.js";

document.addEventListener("DOMContentLoaded", () => {
  addSubheadingsToSidebar();
  markCurrentSubheading();
  bindColorSwatches();
  detectFancyLinks();
  enableToggles();
});

window.addEventListener("scroll", () => {
  markCurrentSubheading();
});
